<div class="confiar-fundo">
  <section #dialogo class="confiar" role="dialog" aria-modal="true"
    aria-labelledby="confiar-titulo" aria-describedby="confiar-texto" (keydown)="manterFoco($event)">

    <p class="confiar__validado">
      <i class="fas fa-check-circle" aria-hidden="true"></i>
      Código confirmado
    </p>

    <h2 class="confiar__titulo" id="confiar-titulo">Confiar neste dispositivo?</h2>
    <p class="confiar__texto" id="confiar-texto">
      Nos próximos {{ rotuloDias }}, entrar por aqui não vai pedir o código de acesso.
    </p>

    <div class="confiar__dispositivo">
      <span class="confiar__dispositivo-icone" aria-hidden="true">
        <i class="fas" [class.fa-mobile-alt]="dispositivo.movel" [class.fa-desktop]="!dispositivo.movel"></i>
      </span>
      <span class="confiar__dispositivo-nome">{{ dispositivo.descricao }}</span>
    </div>

    <p class="confiar__aviso">
      Só um dispositivo fica confiável por vez: o anterior volta a pedir o código.
      Não confie em computador compartilhado.
    </p>

    <div class="confiar__acoes">
      <button #botaoConfiar type="button" class="btn btn-primary confiar__botao"
        [disabled]="processando" (click)="confirmar.emit()">
        <ng-container *ngIf="processando; else rotuloConfiar">Confiando…</ng-container>
        <ng-template #rotuloConfiar>Confiar por {{ rotuloDias }}</ng-template>
      </button>
      <button type="button" class="btn btn-link confiar__recusar"
        [disabled]="processando" (click)="recusar.emit()">
        Agora não
      </button>
    </div>
  </section>
</div>
